import { render, staticRenderFns } from "./QrTypeCard.vue?vue&type=template&id=144c2e2e&scoped=true"
import script from "./QrTypeCard.vue?vue&type=script&lang=js"
export * from "./QrTypeCard.vue?vue&type=script&lang=js"
import style0 from "./QrTypeCard.vue?vue&type=style&index=0&id=144c2e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144c2e2e",
  null
  
)

export default component.exports